import { createActionGroup, emptyProps } from '@ngrx/store';

export const GetUserInfo = createActionGroup({
  source: 'GetUserInfo',
  events: {
    '[GetUserInfo] GetUserInfo': emptyProps(),
  },
});
